export default __webpack_public_path__ + "static/2429-68f9988590f71731e411de6fc4fc67ed.gif";